import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=3d232a42&scoped=true&"
import script from "./KButton.vue?vue&type=script&lang=js&"
export * from "./KButton.vue?vue&type=script&lang=js&"
import style0 from "./KButton.vue?vue&type=style&index=0&id=3d232a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d232a42",
  null
  
)

export default component.exports